// extracted by mini-css-extract-plugin
export var aiStarIcon = "_d5-4";
export var closeButton = "_d5-6";
export var dismissButton = "_d5-3";
export var editImageWithAiContainer = "_d5-8";
export var imageUploadWrapper = "_d5-7";
export var misspelledWord = "_d5-5";
export var spellCheckContainer = "_d5-2";
export var spin = "_d5-1";
export var spinning = "_d5-0";